import { useMutation } from "@tanstack/react-query";
import { restRepository } from "@onair/repositories";

export interface MentorConsultationInput {
	representativeName: string;
	email: string;
	phoneNumber: string;
	consultationContent: string;
}

export interface InhouseTrainingConsultationInput {
	representativeName: string;
	email: string;
	phoneNumber: string;
	trainingTopic: string;
}

export interface ProgramBuildingConsultationInput {
	representativeName: string;
	email: string;
	phoneNumber: string;
	consultationTopic: string;
}

export const useMentorConsultationMutation = () => {
	return useMutation({
		mutationFn: async (input: MentorConsultationInput) => {
			const response = await restRepository.api.mentorRequestCreate(input);
			return response.data;
		},
		onError: (error) => {
			console.error("Mentor consultation error:", error);
		},
	});
};

export const useInhouseTrainingConsultationMutation = () => {
	return useMutation({
		mutationFn: async (input: InhouseTrainingConsultationInput) => {
			const response =
				await restRepository.api.inhouseTrainingRequestCreate(input);
			return response.data;
		},
		onError: (error) => {
			console.error("Inhouse training consultation error:", error);
		},
	});
};

export const useProgramBuildingConsultationMutation = () => {
	return useMutation({
		mutationFn: async (input: ProgramBuildingConsultationInput) => {
			const response =
				await restRepository.api.programConsultationRequestCreate(input);
			return response.data;
		},
		onError: (error) => {
			console.error("Program building consultation error:", error);
		},
	});
};
